"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _APRadioTab = _interopRequireDefault(require("../APRadioTab/APRadioTab"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./APSegmentedButton.css");
var _excluded = ["label", "customClass"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var baseClass = 'ap-segmented-button';
var APSegmentedButton = function APSegmentedButton(props) {
  var label = props.label,
    customClass = props.customClass,
    otherProps = _objectWithoutProperties(props, _excluded);
  var bemClasses = (0, _cssClassesHelper.getBEMClasses)(baseClass, customClass);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('sb-container')
  }, label && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
    className: (0, _classnames["default"])('ap--label', bemClasses('group-label'))
  }, label)), /*#__PURE__*/_react["default"].createElement(_APRadioTab["default"], _extends({
    baseClass: baseClass,
    customClass: customClass
  }, otherProps)));
};
var _default = exports["default"] = APSegmentedButton;